/*
 * @Description: 关怀短信消耗记录
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Button, DatePicker, Select, Form, Icon, Table } from '@alifd/next';
import style from './index.module.scss';
import moment from 'moment';
import utils from '@/common/utils';
import { Servlets } from '@/service';
import LzDialog from '@/components/common/LzDialog';
import OrderCareSendDetail from '@/components/SMS/OrderCareSendDetail';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;

const BASEVAL = {
  startTime: '',
  endTime: '',
  smsTaskType: '',
}

/** 短信消耗记录 */
const OrderCare = (): JSX.Element => {
  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据

  const [typeList, setTypeList] = useState([]);// 短信类型列表

  const [searchFormData, setSearchFormData] = useState({...BASEVAL});// 搜索表单数据集合
  const [dataSource, setDataSource] = useState([] as object[]);// 列表数据
  const [columns, setColumns] = useState([{}]);// 列表title

  const [openDiglog, setOpenDiglog] = useState(false);// 是否打开短消息弹窗--查看发送明细
  const [sendDetailData, setsSendDetailData] = useState({});// 与消息弹窗通信--查看发送明细 -数据传输

  /** 获取列表数据 */
  const getListData = async (searchForm = { endTime: '', startTime: '', smsTaskType: '' }): void => {
    setLoadingForList(true);

    const form = {
      startTime: searchFormData.startTime,
      endTime: searchFormData.endTime,
      smsTaskType: searchFormData.smsTaskType,
    }

    // 获取订单筛选列表数据
    await Servlets('getConsumptionRecord', {
      functionType: 2, // 2:关怀短信
      ...form,
      ...searchForm
    }).then((res) => {
      setLoadingForList(false);// 关闭loading

      if (!res.success) {
        return;
      }

      setDataSource(res.data ?? []); // 获取列表数据
    })
      .catch((err) => {
        console.log(err);
        setLoadingForList(false);/** 关闭loading */
      });
  };

  const getTypeList = async () => {
    await Servlets('getSmsActivityType', {functionType: 2}).then((res) => {
      if (!res.success) {
        return;
      }
      setTypeList([{
             label: '全部',
             value: ''
           }].concat(Object.keys(res.data).map(item => {
        return {
          label: res.data[item],
          value: item
        }
      })));
      getListData({smsTaskType: ''});
    })
      .catch((err) => {
        console.log(err);
      });
  };

  /** 初始化函数 openDialog_SendDetail({ type: "marketing" }) */
  const init = (): void => {
    setColumns(getColumns());
    getTypeList();
  };

  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, []);


  /** 获取 列表数据格式配置项 */
  const getColumns = (): object[] => {
    const columns = [
      {
        title: '活动类型',
        dataIndex: 'type',
        width: 180,
        alignHeader: 'left',
        align: 'left',
      },
      {
        title: '触点类型',
        dataIndex: 'type',
        width: 180,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<div>{value}
                  </div>);
        },
      },
      {
        title: '短信消耗总量 / 条',
        dataIndex: 'sumSmsNum',
        width: 180,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<div>{utils.numFormat(value)}</div>);
        },
      },
      {
        title: '第一次发送时间 - 最新一次发送时间',
        dataIndex: 'startTime',
        width: 190,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<span>
            <span>{record.startTime ? moment(Number(record.startTime)).format('YYYY-MM-DD HH:mm:ss') : ''} </span>--
            <span> {record.endTime ? moment(Number(record.endTime)).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                  </span>);
        },
      },
      {
        title: '操作',
        width: 100,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<div style={{ userSelect: 'none' }}>
            <Button type="primary" text onClick={() => openDialog_SendDetail(record)}>查看明细</Button>
                  </div>);
        },
      },
    ];
    return columns;
  };

  /** 搜索表单提交时触发 */
  const handleSubmit = async (val: any): void => {
    setSearchFormData(val);
    const searchForm = {
      startTime: val.date?.length ? moment(val.date[0] * 1000).unix() : '', // 发送时间  开始
      // endTime: val.date.length ? new Date(`${moment(val.date[1]).format('YYYY-MM-DD')} `).getTime() : '', // 发送时间  结束
      endTime: val.date?.length ? moment(val.date[1]).endOf("day").format('x') : '', // 发送时间  结束
      smsTaskType: val.smsTaskType, // 活动类型

    };
    getListData(searchForm);
  };

  /** 搜索表单重置时触发 */
  const handleReset = async (): void => {
    setSearchFormData({...BASEVAL});
    getListData({ startTime: '', endTime: '', smsTaskType: '' });
  };

  /** 展示短信内容 */
  const openDialog_SendDetail = (record: {} = {}): void => {
    setsSendDetailData(record);
    openDialog_SendDetail_visible(true);
  };


  /** (打开 新建订单筛选营销任务 弹窗) 或(由子组件调用，告知父组件，子组件弹窗是否已关闭) */
  const openDialog_SendDetail_visible = (visible = true): void => {
    setOpenDiglog(visible);
  };

  return (
    <>
      <div>
        <div className={style.SMSConsumeRecord}>
          <div className={style.pageInfoNotice}>
            <div>
              <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
              <div>
                <div>提示：消耗记录中数量显示为短信实际消耗量，官方会在活动短信发送时间3天后进行短信数量的核算和显示</div>
              </div>
            </div>
          </div>

          <div className={style.formAndListStyle}>
            {/* 搜索表单 */}
            <div className={style.listSearch}>
              <Form inline className={style.listSearchForm} size="medium" value={searchFormData}>
                <FormItem label="发送日期:" className={style.formItem}>
                  <RangePicker
                    name="date"
                    placeholder="请点选..."
                    popupAlign="tl tl"
                    className={style.formItem_width}
                    followTrigger
                    disabledDate={(date, view) => utils.disabledDate(date, view, 'back', false)}
                  />
                </FormItem>
                <FormItem label="活动类型:" className={style.formItem}>
                  <Select
                    dataSource={typeList}
                    name="smsTaskType"
                    followTrigger
                    style={{width: 200}}
                  />
                </FormItem>

                <FormItem label="" className={style.formItem}>
                  <Form.Submit
                    className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                    type="primary"
                    onClick={handleSubmit}
                  >查询
                  </Form.Submit>
                  <Form.Reset
                    className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                    onClick={handleReset}
                  >重置
                  </Form.Reset>
                </FormItem>
              </Form>
            </div>

            {/* 列表 */}
            <div className={style.listContent}>
              <div>
                <Table dataSource={dataSource} loading={isLoadingForList} columns={columns}>
                  {
                    columns.map((item: any, index: number) => {
                      return (
                        <Table.Column
                          title={item.title}
                          key={index}
                          dataIndex={item.dataIndex}
                          cell={item.cell}
                          align={item.align}
                          width={item.width}
                          alignHeader={item.alignHeader}
                          lock={item.lock}
                          htmlTitle={item.htmlTitle}
                        />
                      );
                    })
                  }
                </Table>
              </div>
            </div>
          </div>
        </div>
        {/* 弹窗 props可以传递组件参数 */}
        <LzDialog
          shouldUpdatePosition
          isFullScreen
          visible={openDiglog}
          onClose={() => {
            setOpenDiglog(false);
          }}
          footer={false}
          title={sendDetailData.type}
          style={{ width: `${document.body.clientWidth * 0.65 }px` }}
        >
          <OrderCareSendDetail
            startTime={searchFormData?.date?.length ? moment(searchFormData.date[0]).format('YYYY-MM-DD') : ''}
            endTime={searchFormData?.date?.length ? moment(searchFormData.date[1]).format('YYYY-MM-DD') : ''}
            smsTaskType={sendDetailData?.smsTaskType}
          />
        </LzDialog>
      </div>
    </>
  );
};

export default OrderCare;
